import { render, staticRenderFns } from "./scenicAreaManage.vue?vue&type=template&id=5ecd9290&scoped=true"
import script from "./scenicAreaManage.vue?vue&type=script&lang=js"
export * from "./scenicAreaManage.vue?vue&type=script&lang=js"
import style0 from "./scenicAreaManage.vue?vue&type=style&index=0&id=5ecd9290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd9290",
  null
  
)

export default component.exports